import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../common/buttons/SubmitButton'
import Input from '../../common/form/Input'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './MoveFromWaitlistModal.module.scss'
import classNames from 'classnames'

const MoveFromWaitlistModal = ({ showModal, closeModal, onSubmit, event, status, statusLabel }) => {
  const { t } = useTranslation()
  const [coachNote, setCoachNote] = useState(null)


  const handleInputChange = e => {
    setCoachNote(e.target.value)
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles.moveFromWaitlistModal}
      autoFocus
    >
      <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
        <div className='d-flex justify-content-center align-items-center'>
          <WarningIcon/>
        </div>
        <div className={styles.modalContent}>
          <p className={styles.title}>{t('events.modal.moveFromWaitlist.title', { status: statusLabel })}</p>
          <p className={styles.message}>
            {status === 'Attending'
              ? t('events.modal.moveFromWaitlist.attendingMessage')
              : t('events.modal.moveFromWaitlist.otherStatusMessage', { status: statusLabel })
            }
          </p>

          {status === 'Attending' && event.capacityReached &&
            <p className='mb-3'>{t('events.modal.moveFromWaitlist.capacityIncrease', { capacity: event.spotsAvailable + 1 })}</p>
          }

          <span>{t('events.modal.moveFromWaitlist.optionalMessageForFamily')}</span>
          <div className='mt-2 mb-3'>


            <Input
              name='note'
              type='textarea'
              onChange={handleInputChange}
              value={coachNote}
              styles={{ inputContainer: { height: '90px' } }}
            />
          </div>

          <span>{t('events.modal.moveFromWaitlist.familyNotified')}</span>
        </div>
        <div className='w-100 pull-bottom mt-3'>
          <SubmitButton
            onClick={() => onSubmit(status, coachNote)}
            buttonMessage={t('events.modal.moveFromWaitlist.title', { status: statusLabel })}
            buttonColor='orange-button'
          />
          <SubmitButton
            onClick={closeModal}
            buttonMessage={t('common.cancel')}
            buttonColor='navy-button'
          />
        </div>
      </div>
    </Modal>
  )
}

MoveFromWaitlistModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  event: PropTypes.shape({
    spotsAvailable: PropTypes.number.isRequired,
    capacityReached: PropTypes.bool,
  }),
  status: PropTypes.string,
  statusLabel: PropTypes.string,
}

export default MoveFromWaitlistModal
